import { ARTICLE_IMAGE_MAX_BYTES } from "./articleImageLayoutConstants";

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", () => reject(new Error("Impossibile caricare l'immagine per il ritaglio.")));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

const canvasToBlob = (canvas, mimeType, quality) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Impossibile generare l'immagine ritagliata."));
          return;
        }
        resolve(blob);
      },
      mimeType,
      quality
    );
  });

const buildOutputFileName = (sourceName) => {
  const baseName = String(sourceName || "article-image").replace(/\.[^.]+$/, "");
  return `${baseName}-cropped.jpg`;
};

export const readFileAsObjectUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Errore nella lettura del file immagine."));
    reader.readAsDataURL(file);
  });

export const getCroppedImageFile = async (imageSrc, pixelCrop, sourceFileName) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Impossibile inizializzare il canvas per il ritaglio.");
  }

  canvas.width = Math.max(1, Math.round(pixelCrop.width));
  canvas.height = Math.max(1, Math.round(pixelCrop.height));
  context.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  let quality = 0.92;
  let blob = await canvasToBlob(canvas, "image/jpeg", quality);

  while (blob.size > ARTICLE_IMAGE_MAX_BYTES && quality > 0.5) {
    quality -= 0.08;
    blob = await canvasToBlob(canvas, "image/jpeg", quality);
  }

  if (blob.size > ARTICLE_IMAGE_MAX_BYTES) {
    throw new Error("L'immagine ritagliata supera i 2 MB. Prova con un'area più piccola.");
  }

  return new File([blob], buildOutputFileName(sourceFileName), { type: "image/jpeg" });
};
